module.exports = __webpack_public_path__ + "img/sort.41211b15.svg";